import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'

//import vuescroll from "vuescroll/dist/vuescroll-native";
// import the css file 
//import "vuescroll/dist/vuescroll.css";

// Vue.use(vuescroll);

Vue.use(VueResource); 

import VueCircleSlider from 'vue-circle-slider'
Vue.use(VueCircleSlider)

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import './app.scss'
Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.mixin({
  methods: {

    isNull: function (str)
    {
      return (str == '' || str == null || str == undefined);
    },

    api_call: function(settings){

        if (this.isNull(settings.onComplete))
        {
          settings.onComplete = function(){};
        }
        else
        {
          var real_func = settings.onComplete;
          settings.onComplete = function(data){
            real_func(data);
          };
        }
        
        if (settings.async === false) settings.async = false;
        else settings.async = true;
        
        if (this.isNull(settings.data)) settings.data = {};
        settings.data.api_user_token = localStorage.getItem('user_token');
        
        
          return this.$http.post(window.api_url + settings.url, settings.data).then(settings.onComplete);

    },

    is_mobile: function(){ 

      return ( navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
  // || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   );
  }

   }
  })

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')
